import React from 'react';
import styled from 'styled-components';
import { IoIosArrowForward } from 'react-icons/io';
const ScrollBtn = () => {
  return (
    <ScrollBtnWrap>
      <button className='scrollBtn'>
      </button>
      <p>
        Scroll
        <IoIosArrowForward /> 
      </p>
    </ScrollBtnWrap>
  );
};

const ScrollBtnWrap = styled.div`
    width: 162px;
    height:162px;
    position: fixed;
    left:50%; 
    bottom:-50px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    p{
      color:#fff;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      svg{
        transform: rotate(90deg);
        margin-top:5px;
      }
    }
  .scrollBtn{
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    border-radius: 100%;
    animation: pulse 2s infinite alternate;
  }
  @keyframes pulse {
  0% {
    width: 140px;
    height: 140px;
    border:0.5px solid rgba(255, 255, 255, 1);
  }
  100% {
    width: 162px;
    height: 162px;
    border:0px solid rgba(255, 255, 255, 0.1);
  }
}
`

export default ScrollBtn;